import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=ca616c2a&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=ca616c2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca616c2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca616c2a')) {
      api.createRecord('ca616c2a', component.options)
    } else {
      api.reload('ca616c2a', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=ca616c2a&scoped=true&", function () {
      api.rerender('ca616c2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27N4qPRNYJIHo/JS/comp/CookieBox.vue"
export default component.exports